export default __webpack_public_path__ + "static/media/location.25245c5e.svg";